import { editorFocusedEle } from './EditorStore';

export const updateEditorFocusedEle = (value) => editorFocusedEle.update((oldValue) => value);
